export default __webpack_public_path__ + "static/lithuania_jega-b3bfc106ac373c3f9396c6103e3fe9bb.png";